import { render, staticRenderFns } from "./Applicants.vue?vue&type=template&id=6209e3c2&scoped=true"
import script from "./Applicants.vue?vue&type=script&lang=js"
export * from "./Applicants.vue?vue&type=script&lang=js"
import style0 from "./Applicants.vue?vue&type=style&index=0&id=6209e3c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6209e3c2",
  null
  
)

export default component.exports